<template>
  <div class="flex items-center">
    <vs-avatar
      :src="avatar"
      :text="avatarText"
      class="flex-shrink-0 mr-2"
      size="30px"
      @click="onClickNameLink"
    />
    <p @click="onClickNameLink" class="text-inherit link-string truncate ...">
      {{ params.value }}
    </p>
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
export default {
  name: "CellRendererCrewName",
  data() {
    return {
      avatar: null,
      avatarText: "",
    };
  },
  created() {
    if (this.params.data.picture) {
      storage
        .child(this.params.data.picture.thumbnail_path)
        .getDownloadURL()
        .then(response => {
          this.avatar = response;
        });
    } else {
      this.avatarText = this.params.data.crew_name
        ? this.params.data.crew_name.charAt(0)
        : "";
    }
  },
  methods: {
    onClickNameLink() {
      const routeData = this.$router.resolve({
        name: "enterprise-management-crew-labor-record",
        params: { id: this.params.data.enterprise_crew_id },
      });
      window.open(routeData.href, "_blank");
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.link-string {
  color: $aisea-blue;
  cursor: pointer;
}
</style>
